import { createWrapper } from 'next-redux-wrapper'
import { makeStore } from './make-store.simulator'

export type AppStore = ReturnType<typeof makeStore>
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']
export const store = makeStore()
export const wrapper = createWrapper<AppStore>(makeStore, { debug: false })
export const nextJsDataProvider = wrapper.withRedux
